import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  InputContainer,
  ResultsContainer,
  DescriptionContainer,
  ImageContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { PlungePoolVM } from './PlungePoolVM';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';


const PlungePoolComponenet = (props) => {
  const vm = useRef(new PlungePoolVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer computeCallback={() => { vm.computefnPlunge() }} printCallback={() => { vm.launchAndExport() }} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={!vm.hasResults || vm.isLoading || vm.disablePrintBtn}>
          <h2 className='sections-heading'>Pool</h2>
          <div className=''>
            <ComboBox
              idAndName="pool-shape"
              label="Pool Shape"
              aria-label="Pool Shape"
              valid={!vm.formValidation.poolShape}
              value={vm.PlungeFormData.poolShape}
              onChange={(e) => {
                vm.handleInputChange(e);
              }}
              onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
              options={vm.plungePoolOptions}
              errorMsg={''}
              required={true}
              className={`"pool-shape${vm.PlungeErrorClass('poolShape')}`}
            />
          </div>

          <Input
            label="Average Rock Size (in)"
            idAndName="ave-rock-size"
            valid={!vm.formValidation.aveRockSize}
            value={vm.PlungeFormData.aveRockSize}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.PlungeErrorClass('aveRockSize')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <h2 className="sections-heading">Filter </h2>
          <div className='checkbox-container'>
            <label className='label-formula-checkbox usa-label' htmlFor="geo-textile-filter">
              Geotextile Filter
            </label>
            <input
              className="checkbox-input-formulas"
              id="geo-textile-filter"
              data-testid="the-Checkbox"
              type="checkbox"
              name="geo-textile-filter"
              checked={vm.PlungeFormData.geoTextileFilter}
              onChange={(e) => {
                vm.toggleEnableDisableInputs(e.target.name)
              }}
            />
          </div>
          <Input
            label="Filter Thickness (in)"
            idAndName="filter-thickness"
            valid={!vm.formValidation.filterThickness}
            value={vm.PlungeFormData.filterThickness}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            disabled={vm.PlungeFormData.geoTextileFilter}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            className={vm.PlungeErrorClass('filterThickness')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <h2 className='sections-heading'>Side Slopes</h2>
          <div className='checkbox-container'>
            <label className='label-formula-checkbox usa-label' htmlFor="override-side-slopes">
              Override Side Slopes
            </label>
            <input
              className="checkbox-input-formulas"
              id="override-side-slopes"
              data-testid="the-Checkbox"
              type="checkbox"
              name="override-side-slopes"
              checked={vm.PlungeFormData.overrideSideSlopes}
              onChange={(e) => {
                vm.toggleEnableDisableInputs(e.target.name)
              }}
            />
          </div>
          <Input
            label="With Flow (n:1)"
            idAndName="with-flow"
            valid={!vm.formValidation.withFlow}
            value={vm.PlungeFormData.withFlow}
            disabled={!vm.PlungeFormData.overrideSideSlopes}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('withFlow')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Across Flow (n:1)"
            idAndName="across-flow"
            valid={!vm.formValidation.acrossFlow}
            value={vm.PlungeFormData.acrossFlow}
            disabled={!vm.PlungeFormData.overrideSideSlopes}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name,parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('acrossFlow')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <h2 className='sections-heading'>Pipe</h2>
          <Input
            label="Pipe Diameter (in)"
            idAndName="pipe-diameter"
            valid={!vm.formValidation.pipeDiameter}
            value={vm.PlungeFormData.pipeDiameter}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name,parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('pipeDiameter')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Max Pipe Q (cfs)"
            idAndName="max-pipeQ"
            valid={!vm.formValidation.maxPipeQ}
            value={vm.PlungeFormData.maxPipeQ}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('maxPipeQ')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Pipe Slope (ft/ft)"
            idAndName="pipe-slope"
            valid={!vm.formValidation.pipeSlope}
            value={vm.PlungeFormData.pipeSlope}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.0001}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('pipeSlope')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <h2 className='sections-heading'>Elevations</h2>
          <Input
            label="Pipe Outlet Elevation (ft)"
            idAndName="pipe-outlet-elev"
            valid={!vm.formValidation.pipeOutletElev}
            value={vm.PlungeFormData.pipeOutletElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('pipeOutletElev')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Channel Flow Elevation (ft)"
            idAndName="channel-flow-elev"
            valid={!vm.formValidation.channelFlowElev}
            value={vm.PlungeFormData.channelFlowElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('channelFlowElev')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
          <Input
            label="Channel Bottom Elevation (ft)"
            idAndName="channel-bottom-elev"
            valid={!vm.formValidation.channelBottomElev}
            value={vm.PlungeFormData.channelBottomElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.PlungeErrorClass('channelBottomElev')}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
          />
        </InputContainer>
        <div className="col formula-information">
          {vm.hasResults ? (
            <div className="row formula-results">
              <ResultsContainer>
                <div className='col-auto result-value-group '>
                  <div className="row sections-heading">Pool Dimensions</div>
                  <div className="row">
                    <div className="col-10 result-label">At Surface (ft x ft):</div>
                    <div className="col-auto">{vm.plungePoolResults?.atSurface}</div>
                  </div>
                  <div className="row">
                    <div className="col-10 result-label">At Bottom (ft x ft):</div>
                    <div className="col-auto ">{vm.plungePoolResults?.atBottom}</div>
                  </div>
                  <div className="row">
                    <div className="col-10 result-label">Bottom Elevation (ft):</div>
                    <div className="col-auto">{vm.plungePoolResults?.bottomElevation && vm.roundingHelperString(parseFloat(vm.plungePoolResults?.bottomElevation), 2)}</div>
                  </div>
                  <div className="row">
                    <div className="col-10 result-label">Distance to Centerline (ft):</div>
                    <div className="col-auto">{vm.plungePoolResults?.distToCenterline && vm.roundingHelperString(parseFloat(vm.plungePoolResults?.distToCenterline), 2)}</div>
                  </div>
                  <div className="row sections-heading">Quantities</div>
                  <div className="row">

                    {vm.plungePoolResults?.filterVolume ? <><div className="col-10 result-label">Filter material (cu yd):</div>
                      <div className="col-auto">{vm.plungePoolResults.filterVolume && vm.roundingHelperString(parseFloat(vm.plungePoolResults.filterVolume), 2)}</div>
                    </> : <>
                      <div className="col-9 result-label">Geotextile Area (sq ft):</div>
                      <div className="col-auto">{vm.plungePoolResults?.geotextileArea && vm.roundingHelperString(parseFloat(vm.plungePoolResults?.geotextileArea), 2)}</div>
                    </>}

                  </div>
                  <div className="row">
                    <div className="col-10 result-label">Rip-Rap Material (cu yd):</div>
                    <div className="col-auto">{vm.plungePoolResults?.ripRapMaterial && vm.roundingHelperString(parseFloat(vm.plungePoolResults?.ripRapMaterial), 2)}</div>
                  </div>
                  <div className="row">
                    <div className="col-10 result-label">Rip-Rap Thickness (ft):</div>
                    <div className="col-auto">{vm.plungePoolResults?.ripRapThickness && vm.roundingHelperString(parseFloat(vm.plungePoolResults?.ripRapThickness), 2)}</div>
                  </div>

                  <div className="row sections-heading">Pool Side Slope </div>
                  <div className="row">

                    <div className="col-10 result-label">With Flow (n:1):</div>
                    <div className="col-auto">{vm.plungePoolResults?.withFlow}</div>
                  </div>
                  <div className="row">
                    <div className="col-10 result-label">Across Flow (n:1):</div>
                    <div className="col-auto">{vm.plungePoolResults?.acrossFlow}</div>
                  </div>   
                </div>
                {vm.plungePoolResults?.note && vm.plungePoolResults?.note.length > 0 ? 
                  <div className="col-10 result-value-group">
                    <div className="row">
                      <div className="col-auto result-label">Note:</div>
                      <div className="col-auto  long-value">{vm.plungePoolResults?.note.replace(/^(Note\: )/g, '')}</div>
                    </div>
                  </div> 
                : null}
              </ResultsContainer>
            </div>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              {vm.image ?
                <img
                  className="PlungePool-img"
                  src={vm.image}
                  alt={vm.hydraulicFormulaImageDescription}
                  title={vm.formulaTitle}
                /> : null}
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const PlungePoolFormula = observer(PlungePoolComponenet);
